import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { CreateChancel, ToastScreen } from 'components';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, loadActions } from 'store';
import { FindError, FindLoad, FindSuccess, useGlobalTextStyles, useModal } from 'utils';
import { paymentVerificationDetailsStyle } from './styles';
import { toast } from 'react-toastify';

const actionType = 'SEND_TO_CARRIER_EMAIL';

export const SendRemittanceDocument = ({ loadById }) => {
  const dispatch = useDispatch();
  const { close } = useModal();
  const success = FindSuccess(actionType);
  const loading = FindLoad(actionType);
  const beckError = FindError(actionType);
  const globalText = useGlobalTextStyles();
  const classes = paymentVerificationDetailsStyle();


  useEffect(() => {
    if (success?.length) {
      dispatch(httpRequestsOnSuccessActions.removeSuccess(actionType));
      toast(<ToastScreen type={'success'} text='Remittance document has been successfully sent.' />);
      close();
    }
  }, [success]);

  useEffect(() => {
    if (beckError?.length) {
      if (beckError?.[0]?.error) {
        toast(<ToastScreen type={'error'} text={beckError?.[0]?.error} />);
      }
      close();
    }

    return () => {
      dispatch(httpRequestsOnErrorsActions.removeError(actionType));
    };
  }, [beckError]);

  const handleSendToCarrierEmail = () => {
    dispatch(loadActions.sendToCarrierEmail(loadById?.id));
  };

  return (
    <div className={classes.sendRemittanceDocumentWrapper}>
      <h1 className={globalText.modalTitle} style={{ textAlign: 'center' }}>
        Send Remittance Document
      </h1>

      <p className={globalText.modalText} style={{ textAlign: 'center' }}>
        Are you sure you want to send the remittance document to
        <span style={{
          color: '#438BFE',
          margin: '0 3px',
        }}
        >
          {loadById?.carrier?.remittanceEmail ? loadById?.carrier?.remittanceEmail : ''}
        </span>?
        This action cannot be undone.
      </p>

      <CreateChancel
        loader={!!loading}
        create='Send'
        chancel='Go Back'
        width='100%'
        onClose={() => close()}
        onCreate={handleSendToCarrierEmail}
      />
    </div>
  );
};

